import { render } from "./company-achievement-report.vue?vue&type=template&id=6c8c640b&scoped=true"
import script from "./company-achievement-report.vue?vue&type=script&lang=js"
export * from "./company-achievement-report.vue?vue&type=script&lang=js"

import "./company-achievement-report.vue?vue&type=style&index=0&id=6c8c640b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c640b"]])

export default __exports__